export default "__VITE_ASSET__256795e9__"